export default {
  testServer: 'http://172.16.3.252:8071/web/',
  formalServer: 'https://saas.mintoucharge.com/manager/'
}



// WEBPACK FOOTER //
// ./src/utils/serverConfig.js